import * as THREE from "three";
import {gsap} from "gsap";
import Experience from "../Experience.js";
import Environment from "./Environment.js";
import Bulb from "./Bulb.js";
import Cable from "./Cable.js";
import DustParticles from "./DustParticles.js";
import LampSocket from "./LampSocket.js";

export default class World {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.camera = this.experience.camera;
        this.time = this.experience.time;
        this.resources = this.experience.resources;
        
        this.resources.on('ready', () => {
            this.bulb = new Bulb();
            this.cable = new Cable();
            this.particles = new DustParticles();
            this.lampSocket = new LampSocket();
            this.environment = new Environment();
            
            //this.scene.fog = new THREE.FogExp2(0x666666, 0.05);

            this.animate();
        });
    }
    
    update() {
        if (this.bulb) {
            
            const t = this.time.elapsed * 0.001 * 0.2;
            //this.bulb.mesh.position.y = (Math.sin(t) * Math.sin(t*2.3) * Math.sin(t*3.4)) * 0.25 + 2;
        }
    }
    
    animate() {
        this.bulb.light.intensity = 0;
        
        let tl = gsap.timeline();
        tl.fromTo(this.cable.uFillProgress,
            {value: 0},
            {value: 1.05, duration: 3, ease: "power2.in"});
        tl.add(gsap.to(this.bulb.light, {intensity: 10}), ">+=0.2" );

        this.camera.controls.target.copy(this.bulb.mesh.position);
        this.camera.controls.enabled = false;
        
        // Check if we are on a mobile screen (under 768px)
        const isMobile = window.innerWidth <= 768;
        
        // --- 1. Camera Position (Angle & Distance) ---
        const posX = isMobile ? 0 : -0.5;      
        const posY = isMobile ? 3.5 : 2;     
        const posZ = isMobile ? -5 : -4;
        
        this.bulb.mesh.position.y += isMobile ? 1.5 : 0;

        // --- 2. Camera Target (Where the camera looks) ---
        // Replace '0.8' with whatever value you originally used to push the bulb left on desktop!
        const targetX = isMobile ? 0 : -0.5;    // Center on mobile, look away on desktop to push bulb
        const targetY = isMobile ? 4 : 3.5;                     // Keep height at bulb level
        const targetZ = 0;

        const cameraAnimation = gsap.fromTo(
            this.camera.instance.position, 
            {x: 0, y: 0.3, z: isMobile ? -10 : -8}, 
            {
                x: posX, y: posY, z: posZ, duration: 4, ease: "power2.inOut", delay: 0.7
            }
        );

        const cameraTargetAnimation = gsap.fromTo(
            this.camera.controls.target, 
            {x: 0, y: 0.3, z: 0}, 
            {
                x: targetX, y: targetY, z: targetZ, duration: 4, ease: "power2.inOut", delay: 0.7,
                onComplete: () => { 
                    this.camera.controls.enabled = true; 
                    
                    // --- 3. Intro Box Animation ---
                    const introBox = document.getElementById('introBox');
                    if (introBox) {
                        gsap.fromTo(introBox,
                            { 
                                opacity: 0, 
                                // Start slightly lower: 20px down on mobile, -40% on desktop
                                yPercent: isMobile ? 20 : -40 
                            },
                            {
                                opacity: 1, 
                                // End perfectly placed: 0 offset on mobile, -50% center on desktop
                                yPercent: isMobile ? 0 : -50, 
                                duration: 1.5,
                                ease: "power2.out",
                                onStart: () => { introBox.style.pointerEvents = "auto"; }
                            }
                        );
                    }
                }
            }
        );
        
        gsap.fromTo(
            this.environment.sunLight,
            {intensity: 0}, 
            {intensity: 1.5, duration: 3, ease: "power2.inOut", delay: 0.5}
        );
        
        gsap.fromTo(
            this.bulb.filamentMaterial,
            {emissiveIntensity: 0},
            {emissiveIntensity: 12, duration: 1, ease: "power2.inOut", delay: 2.5}
        );
    }
}